import React, { useState, useEffect, useRef } from "react";
// import AboutImage from '../../../assests/images/josurneyt.png';
import ServicesSection from "./servicesData";
import Technologies from "./techCategory";
import Countact_us from '../../mainSection/aboutPage/requestQuote';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from "react-helmet-async";
import one from '../../../assests/staffing/icons/03_sla_4_hours.png'
import two from '../../../assests/staffing/icons/02_highly_qualified_team.png'
import three from '../../../assests/staffing/icons/06_continuous_evaluation.png'
import four from '../../../assests/staffing/icons/04_transparent_communication.png'
import five from '../../../assests/staffing/icons/05_remote_onboarding_support.png'
import six from '../../../assests/staffing/icons/01_round_the_clock_availability.png';
import AboutImage from '../../../assests/service.png'
import HireBanner from '../../../assests/banners/TekIT_Hire_Banner_Dark.png'

const cards = [
  {
    title: "Round The Clock Availability",
    description:
      "Need tech talent anytime? We’ve got you covered! Our experts are available round the clock to ensure seamless project execution.",
    background: six,
  },
  {
    title: "Highly qualified team",
    description:
      "Power up your projects with our Highly Qualified & Dedicated Team! Expert developers, seamless execution. Hire the best, achieve brilliance!",
    background: two,
  },
  {
    title: "SLA 4 Hours",
    description:
      "Swift Support, Guaranteed! With an SLA of just 4 hours, we ensure rapid issue resolution and uninterrupted workflow. Your success, our priority!",
    background: one,
  },
  {
    title: "Transparent Communication",
    description:
      "Transparent Communication, Every Step of the Way! No hidden surprises—just clear, honest, and real-time updates to keep your projects on track.",
    background: four,
  },
  {
    title: "Remote Onboarding & Support",
    description:
      "No geographical limitations when it comes to talent.",
    background: five,
  },
  {
    title: "Continuous Evaluation",
    description:
      "We constantly monitor the quality of work being provided.",
    background: three,
  },

];

const Staffing = () => {
  const sectionRef = useRef(null);
  const formRef = useRef(null);  // <-- Add this line for the form scroll
  const [isVisible, setIsVisible] = useState(false);
  const [bgPositionY, setBgPositionY] = useState(5.69531);
  const [selectedTech, setSelectedTech] = useState("");
 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting, boundingClientRect } = entry;
        const isEnteringFromBottom = isIntersecting && boundingClientRect.top > 0;

        setIsVisible(isEnteringFromBottom);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newPositionY = 5.69531 - scrollY * 0.5;
      setBgPositionY(newPositionY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Custom handler for selecting technology and scrolling to form
  const handleTechSelect = (tech) => {
    setSelectedTech(tech);
    setTimeout(() => {
      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100); // Give React time to update
  };

  const features = [
    {
      title: 'Cost Optimization',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Mask%20Group%204%20-1-.png',
      imgWidth: 180,
      imgHeight: 180,
    },
    {
      title: 'Time Saving Recruitment',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Group 114.png',
      imgWidth: 140,
      imgHeight: 180,
    },
    {
      title: 'Improve Productivity',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Mask Group 4.png',
      imgWidth: 130,
      imgHeight: 185,
    },
    {
      title: 'Availability of Skilled resources',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Group 300.png',
      imgWidth: 130,
      imgHeight: 154,
    },
  ];

  return (
    <div className="z-10">
      <Helmet>
        <title>Top #1 IT Staff Augmentation Services | IT Expert Staffing Solutions</title>
        <meta name="description" content="Boost your business with expert staff augmentation services. Hire top-tier developers for custom IT solutions. Flexible, scalable, and on-time delivery." />
        <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services
" />
        <link rel="preload" as="image" href={HireBanner} type="image/png" />
<link rel='canonical' href='https://www.tekit.io/staffing' />
      </Helmet>
      <section
  ref={sectionRef}
  className="relative pt-24 bg-[#0a2547] overflow-hidden"
>
  {/* Banner image already contains the heading text */}
  <img
    src={HireBanner}
    alt="Hire Dedicated Developers — Fast, Flexible & Pre-Vetted. Contract Staffing, Remote Developers, IT Talent Acquisition"
    className="w-full h-auto block"
    loading="eager" // Important for LCP
  />

  {/* SEO headings (visually hidden, text is in the banner) */}
  <h1 className="sr-only">
    Hire Dedicated Developers — Fast, Flexible & Pre-Vetted
  </h1>
  <h2 className="sr-only">
    Contract Staffing, Remote Developers, IT Talent Acquisition
  </h2>
</section>

      <section className="w-full py-12 px-4 lg:px-8   place-items-center">
        <h1 className="text-black text-[52px] 2xl:text-[40px] lg:text-[32px]">What Makes TekIT Different ?</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-10 text-center mt-6" >
          {cards.map((card, index) => (
            <div
              key={index}
              className="relative rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.25)] group lg:hover:scale-105 transition-transform duration-300 bg-gray-900"
            >
              <div className="flex justify-center items-center">
                <img
                  src={card.background}
                  alt={card.title}
                  className="w-20 h-full py-6 object-contain "
                />

              </div>
              <div className="px-6 pb-4  flex flex-col gap-3">
                <h4 className="text-white font-semibold text-[40px] lg:text-[20px] 2xl:text-[24px]">
                  {card.title}
                </h4>
                <p className="text-white/80 lg:text-[16px] 2xl:text-[18px] text-[36px]">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-[80%] mt-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#00A9E6] rounded-lg p-6 flex gap-4 items-start"
            >
              <img
                src={feature.img}
                alt={feature.title}
                data-aos="fade-up"
                width={feature.imgWidth}
                height={feature.imgHeight}
                className="object-contain"
              />
              <div>
                <h3 data-aos="fade-up" className="text-white text-[32px] 2xl:text-[26px] lg:text-[20px] font-semibold mb-2 font-recoleta">{feature.title}</h3>
                <p data-aos="fade-up" className="text-white text-[24px] 2xl:text-[20px] lg:text-[16px] leading-8 font-recoleta ">{feature.text}</p>
              </div>
            </div>
          ))}
        </div> */}
      </section>
      <section>
        <ServicesSection />
        {/* Pass custom handler to Technologies */}
        <Technologies onSelectTech={handleTechSelect} />
        {/* Wrap form in a ref for scrolling */}
        <div ref={formRef}>
          <Countact_us selectedTech={selectedTech} />
        </div>
      </section>
    </div>
  )
}

export default Staffing;
